<template>
    <div v-if="pagingList.length > 1" class="paging-section cl">
        <div v-for="item in pagingList" :key="item.title" :class="{active: page === item.page}" class="paging-item fl"
             @click="toPage(item)">{{ item.title }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
        },

        limit: {
            type: Number,
            default: 5
        },

        page: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            pagingList: []
        }
    },

    created() {
        this.pagingList = this.calculatePaging({total: this.total});
    },

    watch: {
        total: function (newVal) {
            this.pagingList = this.calculatePaging(newVal);
        },
        page: function () {
            this.pagingList = this.calculatePaging(this.total);
        }
    },

    methods: {
        calculatePaging(total) {
            const limit = this.limit;
            const currentPage = this.page;
            const totalPage = Math.ceil(total / limit);
            const totalButtonSize = 8;
            let result = [];

            for (let i = currentPage - totalButtonSize; i <= currentPage + totalButtonSize; i++) {
                if (i > 0 && i <= totalPage) {
                    result.push({page: i, title: i});
                }
            }

            if (result.length > totalButtonSize) {
                result.sort((a, b) => {
                    return Math.abs(a.page - currentPage) - Math.abs(b.page - currentPage);
                })

                result = result.slice(0, totalButtonSize);
                result.sort((a, b) => {
                    return a.page - b.page;
                });
            }

            if (currentPage > 1) {
                result.unshift({page: currentPage - 1, title: '上一页'})
            }

            if (currentPage < totalPage) {
                result.push({page: currentPage + 1, title: '下一页'})
            }

            return result;
        },

        toPage(item) {
            this.$emit('change', {page: item.page})
        },
    }


}
</script>

<style lang="less" scoped>

.paging-section {
    margin-top: 40px;
}

.paging-item {
    margin: 0 5px;
    background-color: #f4f4f5;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
    height: 28px;
    line-height: 28px;
    box-sizing: border-box;
    text-align: center;
    font-size: 13px;

    padding: 0 4px;
    vertical-align: top;
    cursor: pointer;
}

.paging-item.active {
    background-color: #23252d;
    color: #fff;
}

</style>
